var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "symbol"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 9.76923H16.1538C17.8793 9.76923 18.7421 9.76923 19.3846 10.1402C19.8056 10.3833 20.1552 10.7329 20.3982 11.1538C20.7692 11.7964 20.7692 12.6592 20.7692 14.3846C20.7692 16.11 20.7692 16.9727 20.3982 17.6154C20.1552 18.0364 19.8056 18.386 19.3846 18.629C18.7421 19 17.8793 19 16.1538 19H9.69232M6 9.76923L8.76923 7M6 9.76923L8.76923 12.5385",
    stroke: "#1C274C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.13d23b595ff92100cec3c25a64f3e1a6.svg";
export { ForwardRef as ReactComponent };